import { useCurrentUser } from '../../auth/useCurrentUser';
import { useNow } from '../../data/kioskRefresh';
import { BrandMark } from '../../components/BrandMark';
import { ProfileNavButton } from '../../components/Layout';
import { SecurityCard } from './SecurityCard';
import { FinanceCard } from './FinanceCard';
import { CalendarCard } from './CalendarCard';
import { ThermostatCard } from './ThermostatCard';
import { ComingSoonCard } from './HomeCard';

// The Berg family home screen (app.bergfamilia.com) — the page saved to our
// phones' home screens. Security leads, because it's what we need fastest;
// the other family apps sit in the grid below it.

function greetingFor(d: Date): string {
  const h = d.getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

export function HomePage() {
  const me = useCurrentUser();
  // Re-renders each minute so the greeting and date roll over on their own.
  const now = useNow(60_000);
  const firstName =
    me.status === 'ready' && me.mode === 'real' ? me.user.displayName?.split(' ')[0] : undefined;
  const greeting = greetingFor(now);
  const date = now.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="min-h-dvh bg-canvas">
      {/* Desktop gets the same top bar as the finance section; on a phone the
          greeting row carries the avatar instead and the logo would only
          crowd it. */}
      <div className="hidden lg:block sticky top-0 z-50">
        <header className="app-topbar">
          <span className="brand">
            <BrandMark className="h-6 w-auto" ariaLabel="Berg" />
          </span>
          <div className="topbar-actions">
            <ProfileNavButton />
          </div>
        </header>
      </div>

      <main className="px-4 lg:px-12 pt-[calc(env(safe-area-inset-top)+24px)] pb-[calc(env(safe-area-inset-bottom)+24px)] lg:py-10">
        <div className="mx-auto w-full max-w-[1040px] flex flex-col gap-5 lg:gap-6">
          <div className="flex items-center justify-between px-1 lg:px-0">
            <div className="flex flex-col gap-0.5 lg:gap-1">
              <span className="text-[13px] lg:text-[15px] font-medium text-fg-secondary">
                {date}
              </span>
              <h1 className="text-[26px] lg:text-[34px] font-bold tracking-[-0.02em]">
                {firstName ? `${greeting}, ${firstName}` : greeting}
              </h1>
            </div>
            <div className="lg:hidden">
              <ProfileNavButton />
            </div>
          </div>

          <SecurityCard />

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
            <FinanceCard />
            <CalendarCard />
            <ThermostatCard />
            <ComingSoonCard />
          </div>
        </div>
      </main>
    </div>
  );
}
